/**
 * Definicion de los 6 modos de juego.
 * Fuente unica de verdad para backoffice y app movil.
 */
const GAME_MODES = [
  {
    title: "Causa emoción",
    value: "CAUSA_EMOCION",
    color: "#3498db",
    description:
      "En este modo aprenderás a identificar las situaciones y eventos que desencadenan diferentes emociones. Comprenderás qué circunstancias provocan alegría, tristeza, miedo, enfado y otras emociones básicas. Es el nivel más sencillo, perfecto para empezar a entender el origen de tus emociones.",
  },
  {
    title: "Emoción compleja",
    value: "EMOCION_COMPLEJA",
    color: "#1abc9c",
    description:
      "Este modo te ayuda a reconocer emociones más sofisticadas que surgen de la combinación de emociones básicas. Aprenderás sobre sentimientos como la nostalgia, los celos, la vergüenza, el orgullo y la gratitud. Requiere un análisis más profundo de tus estados emocionales.",
  },
  {
    title: "Deseo Emoción",
    value: "DESEO_EMOCION",
    color: "#f1c40f",
    description:
      "Aquí explorarás la relación entre tus deseos, expectativas y las emociones que experimentas. Entenderás cómo lo que quieres o esperas influye en cómo te sientes. Aprenderás a identificar la conexión entre tus anhelos y tu estado emocional.",
  },
  {
    title: "Pensamiento emoción",
    value: "PENSAMIENTO_EMOCION",
    color: "#e67e22",
    description:
      "En esta modalidad descubrirás cómo tus pensamientos, creencias y la forma en que interpretas las situaciones afectan directamente a tus emociones. Aprenderás que no son los eventos en sí, sino cómo los piensas, lo que determina cómo te sientes. Es fundamental para la gestión emocional.",
  },
  {
    title: "Interacciones",
    value: "INTERACCION",
    color: "#e74c3c",
    description:
      "Este modo se centra en las emociones que surgen en el contexto social. Aprenderás a identificar y comprender las emociones que aparecen en tus relaciones con los demás: empatía, compasión, envidia social, admiración y otras emociones interpersonales. Es clave para mejorar tus habilidades sociales.",
  },
  {
    title: "Todas",
    value: [
      "CAUSA_EMOCION",
      "EMOCION_COMPLEJA",
      "DESEO_EMOCION",
      "PENSAMIENTO_EMOCION",
      "INTERACCION",
    ],
    color: "#c0392b",
    description:
      "El modo más completo y desafiante. Combina todos los aspectos anteriores: causas, emociones complejas, deseos, pensamientos e interacciones. Requiere un dominio integral de la inteligencia emocional. Ideal para quienes buscan el máximo reto y un conocimiento profundo de sus emociones.",
  },
];

const ALL_MODE_VALUES = [
  "CAUSA_EMOCION",
  "EMOCION_COMPLEJA",
  "DESEO_EMOCION",
  "PENSAMIENTO_EMOCION",
  "INTERACCION",
];

function getModeByTitle(title) {
  return GAME_MODES.find((m) => m.title === title) || null;
}

function getSessionType(modeValue) {
  return Array.isArray(modeValue) ? modeValue.join(",") : modeValue;
}

module.exports = { GAME_MODES, ALL_MODE_VALUES, getModeByTitle, getSessionType };
